module.exports = __webpack_public_path__ + "img/logo.0998cb77.png";